export default "__VITE_ASSET__Bz7cJ0KA__"